import { render, staticRenderFns } from "./MyTask.vue?vue&type=template&id=28c7aad0&scoped=true"
import script from "./MyTask.vue?vue&type=script&lang=js"
export * from "./MyTask.vue?vue&type=script&lang=js"
import style0 from "./MyTask.vue?vue&type=style&index=0&id=28c7aad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c7aad0",
  null
  
)

export default component.exports